import React from 'react';
import { SvgIconProps } from '../types';

export default function CalendarCheck({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45 45"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.5 0C32.4944 0 33.2998 0.80606 33.2998 1.7998V5.40039H36.9004C38.3323 5.40044 39.7061 5.9689 40.7188 6.98145C41.7313 7.99399 42.2997 9.36794 42.2998 10.7998V39.6006C42.2997 41.0322 41.731 42.4055 40.7188 43.418C39.7062 44.4306 38.3323 44.9999 36.9004 45H8.10059C6.66859 45 5.29489 44.4306 4.28223 43.418C3.2697 42.4055 2.70032 41.0324 2.7002 39.6006V10.7998C2.70027 9.36791 3.26968 7.99404 4.28223 6.98145C5.29481 5.969 6.66878 5.40039 8.10059 5.40039H11.7002V1.7998C11.7002 0.806088 12.5057 9.73918e-05 13.5 0C14.4944 0 15.2998 0.80606 15.2998 1.7998V5.40039H29.7002V1.7998C29.7002 0.806097 30.5057 0.000111304 31.5 0ZM6.30078 18.9004V39.5996C6.30079 40.0767 6.49039 40.5343 6.82812 40.8721C7.16586 41.2097 7.62355 41.3994 8.10059 41.3994H36.9004C37.3775 41.3994 37.8351 41.2098 38.1729 40.8721C38.5106 40.5343 38.7002 40.0767 38.7002 39.5996V18.9004H6.30078ZM8.10059 9C7.10679 9 6.30078 9.80604 6.30078 10.7998V15.2998H38.7002V10.7998C38.7002 10.3228 38.5105 9.86508 38.1729 9.52734C37.8351 9.18963 37.3775 9.00005 36.9004 9H33.2998V9.90039C33.2997 10.3774 33.1101 10.8358 32.7725 11.1729C32.4353 11.5105 31.977 11.7002 31.5 11.7002C30.5058 11.7001 29.7003 10.894 29.7002 9.90039V9H15.2998V9.90039C15.2997 10.3774 15.1101 10.8358 14.7725 11.1729C14.4353 11.5105 13.977 11.7002 13.5 11.7002C12.5057 11.7001 11.7003 10.894 11.7002 9.90039V9H8.10059Z"
        fill={fill}
      />
      <g transform="translate(11.5, 23)">
        <path
          d="M1.5 5.38235L8.24194 12.5L20.5 1.5"
          stroke={fill}
          stroke-width="3"
          stroke-linecap="round"
        />
      </g>
    </svg>
  );
}
